import { Component, DestroyRef, OnInit } from '@angular/core';
import { DestroyService } from '../../../services/destroy/destroy.service';
import { OrderModel, OrderProductModel, OrderServiceProxy, OrderStatus, OrderUpdateModel, SubscriptionModel } from '../../../../shared/service-proxies/event-service-proxy';
import { ActivatedRoute } from '@angular/router';
import { takeUntil } from 'rxjs';
import { ModalService } from '../../../services/modal/modal.service';
import { ErrorService } from '../../../services/error/error.service';
import { TableColumn } from '../../../interfaces/table-column.interface';

@Component({
    selector: 'app-order-page',
    templateUrl: './order-page.component.html',
    styleUrl: './order-page.component.scss',
    providers: [DestroyService],
    standalone: false
})
export class OrderPageComponent implements OnInit {

  public orderId: string = '';
  public order: OrderModel = new OrderModel();
  orderForm: OrderUpdateModel = new OrderUpdateModel();
  public orderOriginal: OrderModel = new OrderModel();
  public products: OrderProductModel[] = [];

  public subscriptions: SubscriptionModel[] = [];

  public activeModal: 'payment' | 'cancel' | null = null;
  
  customerId: string = '';
  isLoading: boolean = true;
  restoreBtnVisible: boolean = false;

  dataMissingProducts: boolean|string = false || '';
  dataMissingSubscriptions: boolean|string = false || '';

  public columnsProducts: TableColumn[] = [
    { header: 'ID', field: 'id', col: 4 },
    { header: 'Название', field: 'name', col: 4 },
    { header: 'Создан', field: 'createdAt', col: 4 },
    { header: 'Описание', field: 'description', col: 6 },
    { header: 'Сумма', field: 'price', col: 2},
  ];

  public columnsSubscriptions: TableColumn[] = [
    { header: 'Логин', field: 'login', col: 2, isCopyable: true },
    { header: 'Пароль', field: 'password', col: 2, isCopyable: true },
    { header: 'Товар', field: 'orderProduct.name', col: 3 },
    { header: 'Цена', field: 'orderProduct.price', col: 2 },
    { header: 'Создан', field: 'createdAt', col: 3 },
    { header: 'Активирован', field: 'activatedAt', col: 3 },
    { header: 'Заканчивается', field: 'expiresAt', col: 3 },
    { header: 'Смотрел', field: 'lastSeenAt', col: 4 },
    { header: '', field: 'isActive', col: 4, },
    { header: '', field: 'btnProlong', col: 4},
  ];

  public heightTable = {
    heightTable: 'auto',
    heightBody: '150px'
  }

  constructor(private errorService: ErrorService, private _orderService: OrderServiceProxy, private destroyService: DestroyService, private route: ActivatedRoute, public modalService: ModalService) {
    this.orderId = this.route.snapshot.params.id;
  }

  ngOnInit(): void {
    this.getOrder();
  }

  getOrder() {
    const subscriptions: SubscriptionModel[] = [];
   
    this._orderService.getDetails(this.orderId)
      .pipe(takeUntil(this.destroyService.onDestroy$))
      .subscribe(order => {
        this.order = order; 
        this.orderOriginal = order; 
        this.orderForm = order;
        this.products = order.products;
        this.dataMissingProducts = this.products.length == 0;
        this.isLoading = false;
        this.products.forEach(p => {
          if (p.subscription) {
            const orderProduct: OrderProductModel = new OrderProductModel();
            orderProduct.name = p.name;
            orderProduct.price = p.price;
            p.subscription.orderProduct = orderProduct;
            subscriptions.push(p.subscription)
            console.log(subscriptions);
            
          }
        })
        this.subscriptions = subscriptions;
        this.dataMissingSubscriptions = this.subscriptions.length == 0;
        console.log(this.products);
      }, error => {
        console.error(error);
        this.isLoading = false;
        this.dataMissingSubscriptions = 'Не удалось получить список подписок. Попробуйте позже.';
        this.dataMissingProducts = 'Не удалось получить список товаров. Попробуйте позже.';
        this.errorService.handleError(error, 'Не удалось получить заказ. Попробуйте позже.');
      })
  }

  

  getOrderStatuses(status: OrderStatus): string {
    switch (status) {
      case OrderStatus.Draft:
        return "Черновик";
      case OrderStatus.New:
        return "Новый";
      case OrderStatus.Paid:
        return "Оплаченный";
      case OrderStatus.Processing:
        return "В обработке";  
      case OrderStatus.Completed:
        return "Завершенный";
      case OrderStatus.Cancelled:
        return "Отмененный";
      default:
        return "";
    }
  }
  changeOrderStatusesColor(status: OrderStatus): string {
    switch (status) {
      case OrderStatus.Draft:
        return "Черновик";
      case OrderStatus.New:
        return "color_dark_green";
      case OrderStatus.Paid:
        return "color_green";
      case OrderStatus.Processing:
        return "color_violet";  
      case OrderStatus.Completed:
        return "color_violet";
      case OrderStatus.Cancelled:
        return "color_red";
      default:
        return "";
    }
  }

  openModal(type: 'payment' | 'cancel') {
    this.activeModal = type;
    this.modalService.openModal(type);
  }
  
  // getPayments() {
  //   this._orderService.getPayments(this.orderId, 1, 10).subscribe((res) => {
  //     console.log(res);
  //   })
  // }
}
